import { message } from "ant-design-vue";

import {
  productionOrderPage,
  completeOrderPage,
  workGroupOrderPage,
  completeWorkGroupOrderPag,
  deviceOrderPage, //getDetailAttrList,
  // orderDetail, getCustomFieldVals
} from "@api";
import Vue from "vue";
export default {
  state: {
    //当前选中工单
    workOrder: null,
    materiel: null,
    //订单
    order: null,
    // 流程工单
    flowOrder: null,
    DeviceWorkOrderid: null,
    DeviceWorkOrderid2: null,
    completeNum: null,
    refreshFlag: false, // 新增刷新标记
    // 吹膜设备id
    cmDeviceid: null,
    //工单事件定义
    workOrderEvent: {
      refresh: "refreshOrderTable",
    },
    //显示类型 0：工单列表  1：查看图纸
    displayType: localStorage.getItem("displayType") || 0,
    orderTables: {
      production: {
        title: "工位工单",
        key: "PRODUCTION_ORDER",
        dataApi: productionOrderPage,
        orderCount: 0,
      },
      complete: {
        title: "工位完成工单",
        key: "COMPLETE_ORDER",
        dataApi: completeOrderPage,
        orderCount: 0,
      },
      toReceive: {
        title: "班组工单",
        key: "TO_RECEIVE_ORDER",
        dataApi: workGroupOrderPage,
        orderCount: 0,
      },
      toTeam: {
        title: "班组完成工单",
        key: "TO_COMPLETE_RECEIVE_ORDER",
        dataApi: completeWorkGroupOrderPag,
        orderCount: 0,
      },
      Current: {
        title: "当前生产工单",
        key: "Current",
        dataApi: deviceOrderPage,
        params: {
          productStatus: ["PRODUCED"],
        },
      },
    },
    //工单详情
    workOrderDetail: null,
    //工单对应工序详情
    processCustomFieldVals: null,
    //当前展示工单列表类型
    currOrderType: "PRODUCTION_ORDER",
    //当前工单工序类型
    currProcessCategory: null,
    //搜索表单
    workOrderParams: {
      materielName: null,
      materielCode: null,
      batchCode: null,
    },
  },
  mutations: {
    setRefresh(state) {
      state.refreshFlag = !state.refreshFlag; // 取反切换状态
    },
    setcmDeviceid(state, cmDeviceid) {
      state.cmDeviceid = cmDeviceid;
    },
    setMateriel(state, materiel) {
      state.materiel = materiel;
    },
    setOrder(state, order) {
      state.order = order;
    },
    setFlowOrder(state, flowOrder) {
      state.flowOrder = flowOrder;
    },
    setDeviceWorkOrderid(state, DeviceWorkOrderid) {
      state.DeviceWorkOrderid = DeviceWorkOrderid;
    },
    setDeviceWorkOrderid2(state, DeviceWorkOrderid2) {
      state.DeviceWorkOrderid2 = DeviceWorkOrderid2;
    },
    setWorkOrder(state, workOrder) {
      state.workOrder = workOrder;
    },
    setCompleteNum(state, completeNum) {
      state.completeNum = completeNum;
    },
    setDisplayType(state, displayType) {
      localStorage.setItem("displayType", displayType);
      state.displayType = displayType;
    },
    setTargetOrderCount({ orderTables }, { key, total }) {
      Object.keys(orderTables).forEach((talbeKey) => {
        let orderTable = orderTables[talbeKey];
        if (orderTable.key == key) {
          orderTable.orderCount = total;
        }
      });
    },
    //设置当前展示工单列表类型
    setCurrOrderType(state, currOrderType) {
      state.currOrderType = currOrderType;
    },
    //设置当前工单工序类型
    setCurrProcessCategory(state, currProcessCategory) {
      state.currProcessCategory = currProcessCategory;
    },
    //设置工单详情数据
    setWorkOrderDetail(state, workOrderDetail) {
      state.workOrderDetail = workOrderDetail;
    },
    setProcessCustomFieldVals(state, processCustomFieldVals) {
      state.processCustomFieldVals = processCustomFieldVals;
    },
  },
  actions: {
    /** 检查是否存在工单 */
    workOrderExist({ state }) {
      if (!state.workOrder) {
        message.warn("请先选中!");
        return false;
      }
      return true;
    },
    /** 刷新生产工单列表 */
    refreshProductionTable({ state }, resetPage) {
      this.dispatch("refreshTable", {
        tableKey: state.orderTables.production.key,
        resetPage,
      });
      this.dispatch("refreshTable", {
        tableKey: state.orderTables.Current.key,
        resetPage,
      });
      //刷新工单详情
    },
    /** 刷新完工工单列表 */
    refreshCompleteTable({ state }, resetPage) {
      this.dispatch("refreshTable", {
        tableKey: state.orderTables.complete.key,
        resetPage,
      });
    },
    /** 刷新待领取工单列表 */
    refreshReceiveTable({ state }, resetPage) {
      this.dispatch("refreshTable", {
        tableKey: state.orderTables.toReceive.key,
        resetPage,
      });
    },
    // /** 刷新报检验工单 */
    // refreshInspectionWorkorder({
    // 	state
    // }, resetPage) {
    // 	this.dispatch('refreshTable', {
    // 		tableKey: state.orderTables.InspectionWorkorder.key,
    // 		resetPage
    // 	})
    // },
    /** 刷新工单列表 */
    refreshTable({ state }, params) {
      Vue.prototype.$bus.$emit(state.workOrderEvent.refresh, params);
    },
    /** 刷新上料记录列表 */
    refreshLoadMaterielTable() {
      Vue.prototype.$bus.$emit("refreshLoadMaterielTable");
    },

    // /** 刷新工单详情 */
    // async refreshWorkOrderDetail({ getters }) {
    // 	if (getters.getWorkOrderId) {
    // 		const { data } = await orderDetail(getters.getWorkOrderId)
    // 		this.commit('setWorkOrderDetail', data)
    // 		const processData = await getCustomFieldVals({ 'dataId': getters.getWorkOrderDetail.processId ,'moduleCode':'PROCESS','dataSupply': "APP"})
    // 		this.commit('setProcessCustomFieldVals', processData.data)
    // 	}
    // },
    /** 搜索 */
    async workOrderSearch() {
      this.commit("setWorkOrder", null);
      this.commit("setWorkOrderDetail", null);
      this.commit("setProcessCustomFieldVals", null);
      this.dispatch("refreshAllTable");
    },
    /** 重置搜索 */
    async resetWorkOrderSearch({ state }) {
      Object.keys(state.workOrderParams).forEach((key) => {
        state.workOrderParams[key] = null;
      });
      this.dispatch("workOrderSearch");
    },
    //刷新所有表格
    refreshAllTable() {
      this.dispatch("refreshProductionTable", true);
      this.dispatch("refreshCompleteTable", true);
      this.dispatch("refreshReceiveTable", true);
    },
    //比较工单id进行刷新或者重置选中工单 报工id和当前选中的工单id相同 则代表当前工单已经被报工 所以要重置选中工单
    resetWorkOrderId({ getters }, id) {
      console.log("match：", id, getters.getWorkOrderId);
      if (getters.getWorkOrderId == id) {
        //报工id和当前选中的工单id相同 清除选中的工单
        this.dispatch("workOrderSearch");
      } else {
        //报工id和当前选中的工单id不同 只刷新列表
        this.dispatch("refreshAllTable");
      }
    },
  },
  getters: {
    getRefresh(state) {
      return state.refreshFlag;
    },
    getcmDeviceid(state) {
      return state.cmDeviceid || null;
    },
    getMateriel(state) {
      return state.materiel || null;
    },
    getOrder(state) {
      return state.order || null;
    },
    getFlowOrder(state) {
      return state.flowOrder || null;
    },
    getDeviceWorkOrderidrow(state) {
      return state.DeviceWorkOrderid || null;
    },
    getDeviceWorkOrderid(state) {
      if (state.DeviceWorkOrderid) {
        return state.DeviceWorkOrderid.id || null;
      } else {
        return null;
      }
    },
    getDeviceWorkOrderidrow2(state) {
      return state.DeviceWorkOrderid2 || null;
    },
    getWorkOrder(state) {
      return state.workOrder || {};
    },
    getCompleteNum(state) {
      return state.completeNum || {};
    },
    getWorkOrderId(state, getters) {
      return getters.getWorkOrder.id;
    },
    getWorkOrderProcessId(state, getters) {
      return getters.getWorkOrder.processId;
    },
    getWorkOrderDetail(state) {
      return state.workOrderDetail || {};
    },
    //工单对应工序详情列表数据
    getProcessCustomFieldVals(state) {
      return state.processCustomFieldVals || {};
    },
    //工单详情列表数据
    getDetailAttrList(state, getters) {
      let list = [];
      if (!state.workOrderDetail) return list;
      getters.getWorkOrderSettings.forEach((item) => {
        if (!item.display) return;
        let fieldKeys = item.fieldKey.split(".");
        let value = JSON.parse(JSON.stringify(state.workOrderDetail));
        fieldKeys.forEach((field) => {
          if (value) {
            value = value[field];
          }
        });
        if (item.name == "工人" && getters.getWorkOrderId)
          value = state.userInfo.userName;
        else if (item.name == "首次检验报告" && getters.getWorkOrderId)
          value = item.value ? "需要" : "不需要";
        list.push({ name: item.name, value: value });
      });
      // console.log(list)
      return list;
    },
    //如果获取不到 则抛出异常
    mustGetWorkOrderId(state, getters) {
      if (!getters.getWorkOrderId) {
        message.warning("请先选中工单!");
        throw new Error("请先选中工单!");
      }
      return getters.getWorkOrderId;
    },
    //获取当前工序标签集合
    getCurrProcessTabs(state) {
      return (
        state.currProcessCategory?.tabs?.map((item) => item.processTab) || []
      );
    },
  },
};
